import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './fonts/fonts.css';
import { BreakpointProvider, IBreakpoints } from './hooks/useBreakpoint';
import store from './redux/store';
import App from './App';
import i18n from './localization/i18n';
import registerServiceWorker from './registerServiceWorker';
import Theme from './Theme';
import './Styles.scss';
import { SnackbarProvider } from 'notistack';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY);

const queries: { [Property in keyof IBreakpoints]: string } = {
    isDesktop: '(min-width: 1025px)',
    isTablet: '(min-width: 600px) and (max-width: 1024px)',
    isMobile: '(max-width: 599px)',
};

createRoot(document.getElementById('root')).render(
    <Provider store={store}>
        <BreakpointProvider queries={queries}>
            <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                    <ThemeProvider theme={Theme}>
                        <SnackbarProvider
                            maxSnack={3}
                            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                            SnackbarProps={{ style: { top: '44px' } }}
                        >
                            <App />
                        </SnackbarProvider>
                    </ThemeProvider>
                </I18nextProvider>
            </BrowserRouter>
        </BreakpointProvider>
    </Provider>,
);

registerServiceWorker();
